<template>
  <div>
    <CompanyNumberInput class="tw-mt-4" market="SG">
      <div class="tw-mt-1">
        <BusinessEntityInput
          v-model="companyNo"
          :error="errorCompanyNo"
          label=""
          placeholder="518247535"
          name="company_no"
          @focusout="v$.companyNo.$touch"
        />
      </div>
    </CompanyNumberInput>
    <div class="tw-mt-5">
      <BusinessEntityInput
        v-model="companyName"
        :error="errorCompanyName"
        :label="$t('Registered company name')"
        name="company_name"
        @focusout="v$.companyName.$touch"
      />
    </div>
    <BusinessEntityVat
      v-model:business-entity="internalBusinessEntity"
      :compliance-data="complianceData"
      market="SG"
      class="tw-mt-5"
    />
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { computed, ref } from 'vue'
import BusinessEntityInput from '@/components/compliances/BusinessEntity/BusinessEntityInput.vue'
import BusinessEntityVat from '@/components/compliances/BusinessEntity/BusinessEntityVat.vue'
import CompanyNumberInput from '@/components/compliances/BusinessEntity/CompanyNumberInput.vue'
import {
  commonCompanyName,
  sgCompanyNumber,
} from '@/components/compliances/BusinessEntity/Validations/BusinessEntityValidationRules'
import { useValidatorWithGraphQlError } from '@/composables/errors'

export default {
  components: {
    BusinessEntityInput,
    BusinessEntityVat,
    CompanyNumberInput,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
    complianceData: {
      type: Object,
      required: true,
    },
    errorsGraphql: {
      type: Object,
      default() {
        return null
      },
    },
  },
  emits: ['update:businessEntity'],
  setup(props, { emit }) {
    const v$ = useVuelidate()
    const errors = ref(props.errorsGraphql)

    const internalBusinessEntity = ref(props.businessEntity)

    const companyName = computed({
      get() {
        return internalBusinessEntity.value.companyName
      },

      set(value) {
        internalBusinessEntity.value.companyName = value
        v$.value.companyName.$touch()
        emit('update:businessEntity', internalBusinessEntity.value)
      },
    })
    const errorCompanyName = useValidatorWithGraphQlError(
      v$,
      errors,
      'companyName',
      'registered_company_name',
    )

    const companyNo = computed({
      get() {
        return internalBusinessEntity.value.companyNo
      },
      set(value) {
        internalBusinessEntity.value.companyNo = value
        v$.value.companyNo.$touch()
        emit('update:businessEntity', internalBusinessEntity.value)
      },
    })
    const errorCompanyNo = useValidatorWithGraphQlError(v$, errors, 'companyNo', 'company_no')

    return {
      companyName,
      companyNo,
      errorCompanyName,
      errorCompanyNo,
      internalBusinessEntity,
      v$,
    }
  },

  validations() {
    return {
      companyName: commonCompanyName(),
      companyNo: sgCompanyNumber(),
    }
  },
}
</script>
